import Home from "./components/Home";
import ReconcilePage from "./components/stats/reconcile/ReconcilePage";
import ResultsPage from "./components/stats/results/ResultsPage";
import BackofficePage from "./components/stats/backoffice/BackofficePage";


const AppRoutes = [
  {
    index: true,
    path: '/',
    element: <Home />,
    isPrivate: true,
    label: "Reports",
    icon: "file-lines",
    showInMenu: true
  },
  {
    path: '/reconcile',
    element: (
      <ReconcilePage
        caption="Riconciliazione fatture elettroniche ricevute"
      />
    ),
    isPrivate: true
  },
  {
    path: '/results',
    element: <ResultsPage />,
    isPrivate: true
  },
  {
    path: "/backoffice",
    element: <BackofficePage />,
    isPrivate: true,
    roles: ["Administrators"],
    label: "Backoffice",
    icon: "users-gear",
    showInMenu: true
  }
];

export default AppRoutes;
